import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

import Components from "../components"

import LandingHeader from "../components/landing-header"
import Footer from "../components/footer"
import MetaData from "../components/meta-data"
import Navigation from "../components/navigation"

import getSectionsAnchors from "../helpers/handleSectionAnchors"

const LandingLayout = ({ globalData, blok, path }) => (
  <>
    <LandingHeader blok={globalData} cta={blok.cta} fixed={blok.fixed_header}/>
    <SbEditable content={blok}>
      {blok.meta_data &&
        blok.meta_data.map(md => (
          <MetaData key={md._uid} meta_data={md} path={path} />
        ))}
      <div className="full-container">
        {blok.header &&
          blok.header.map(content => {
            if (content.component === "navigation") {
              return (
                <Navigation
                  key={content._uid}
                  anchorList={getSectionsAnchors(blok.body)}
                />
              )
            }
            return (
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )
          })}
        {blok.body &&
          blok.body.map(
            content =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
          )}
      </div>
    </SbEditable>
    {globalData.footer &&
      globalData.footer.map(footer => (
        <Footer key={footer._uid} blok={footer} landingFooter={true} />
      ))}
  </>
)

LandingLayout.defaultProps = {
  children: [],
}

LandingLayout.propTypes = {
  blok: PropTypes.shape({
    meta_data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    header: PropTypes.arrayOf(PropTypes.object),
    body: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  globalData: PropTypes.shape({
    header_menu: PropTypes.arrayOf(PropTypes.object),
    header_cta: PropTypes.arrayOf(PropTypes.object),
    footer: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  path: PropTypes.string.isRequired,
}

export default LandingLayout
